import * as React from 'react';
import { cn } from '../../lib';

interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const LoadingState = ({ message = 'Cargando...', size = 'md', className }: LoadingStateProps) => {
  const sizes = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center py-8', className)}>
      <div
        className={cn('animate-spin rounded-full border-2 border-primary border-t-transparent', sizes[size])}
        role="status"
        aria-label={message}
      >
        <span className="sr-only">{message}</span>
      </div>
      {message && <p className="mt-3 text-sm text-muted-foreground">{message}</p>}
    </div>
  );
};

export { LoadingState };